var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "studentList" },
    _vm._l(_vm.users, function (item, index) {
      return _c("li", { key: index }, [
        _c("img", {
          attrs: { src: require("@/assets/tic/qq/5.gif"), alt: "" },
        }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(item.name))]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/studentList.vue?vue&type=template&id=0c6c0472&scoped=true&
// module id = null
// module chunks = 